<template>
    <div>
        <mini-button :disable="theStatus==null || disable"
                     @btnClick="openComplete">
            <i class="fa-solid fa-check"></i>
        </mini-button>
        <re-b-modal ref="complete" header="任务" superLarge hide-header hide-footer>
            <workflow-task-complete v-if="theStatus!=null"
                                    :config="config"
                                    :status="theStatus"
                                    syncValueChange
                                    multi-task
                                    :use-self-complete-task="useSelfCompleteTask"
                                    :use-self-complete-feedback="!noUseSelfCompleteFeedback"
                                    @complete="doComplete">
            </workflow-task-complete>
        </re-b-modal>
        <re-b-modal ref="viewTable" header="Table" no-close-on-backdrop superLarge>
            <mini-table :entity-name="entityName"
                        :custom-vuex-name="customVuexName"
                        :items="rows"
                        need-model-fields
                        read-only
                        with-custom-actions-head-of-row
                        custom-head-of-row-label="状态">
                <template #headOfRow="{row}">
                    <template v-if="runningStatusMap[row.id]">
                        <b-spinner small v-if="runningStatusMap[row.id].loading" type="border"></b-spinner>
                        <i v-else :class="runningStatusMap[row.id].class"></i>
                        <div v-if="runningStatusMap[row.id].isFailed" class="error-msg">
                            {{ errorMsg[row.id] }}
                        </div>
                    </template>
                </template>
            </mini-table>
        </re-b-modal>
    </div>
</template>

<script>

const RUN = {
    START: {loading: true},
    DONE: {class: 'fa-solid fa-check text-success', isSucceeded: true},
    FAILED: {class: 'fa-solid fa-xmark text-danger', isFailed: true},
    SKIP: {class: 'fa-solid fa-arrow-right text-secondary'}
}

import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
    name: "WorkflowTaskMultipleBtn",
    mixins: [emCommonUtilMixin],
    components: {MiniTable, ReBModal, MiniButton, WorkflowTaskComplete},
    props: {
        rows: {
            type: Array
        },
        config: Object,
        acceptStatus: String,
        //自定义完成任务
        useSelfCompleteTask: {
            type: Boolean,
            default: false
        },
        //自定义完成任务回调
        noUseSelfCompleteFeedback: {
            type: Boolean,
            default: false
        },
        entityName: String,
        customVuexName: String,

        disable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            runningStatusMap: {},
            errorMsg: {},
            running: false,
        }
    },
    computed: {
        theStatus() {
            let temp = null;
            if (this.rows && this.rows.length > 0) {
                for (let row of this.rows) {
                    if (temp == null) {
                        temp = row.status;
                    } else if (temp !== row.status) {
                        return null;
                    }
                }
            }
            if (temp != null) {
                if (this.hasCode(this.acceptStatus) && !this.acceptStatus.split(",").includes(temp)
                    || !this.config || !this.config.hasOwnProperty(temp)) {
                    return null;
                }
            }
            return temp;
        },
    },
    methods: {
        openComplete() {
            this.$refs.complete.showModal();
        },
        doComplete(form) {
            if (form && this.theStatus != null) {
                this.$refs.viewTable.showModal();
                this.$refs.viewTable.changeLoading(true);
                this.doOneByOne(form, 0);
            }
        },
        doOneByOne(form, index) {
            if (index >= this.rows.length) {
                this.$refs.viewTable.changeLoading(false);
                this.$message.success("执行完成");
                if (this.checkAllSuccess()) {
                    this.$refs.viewTable.hide();
                    this.$refs.complete.hide();
                    this.clearRunningStatus();
                    this.$emit('finish');
                }
                return;
            }
            let row = this.rows[index];
            let id = row.id;
            let runStatus = this.runningStatusMap[id];
            if (!runStatus || !runStatus.isSucceeded) {
                if (row && row.workflowTask && row.workflowTask.taskInstanceId) {
                    this.$set(this.runningStatusMap, id, RUN.START);
                    let tempForm = this.deepCopyObj(form.form);
                    tempForm.taskId = row.workflowTask.taskInstanceId;
                    if (tempForm.requests) {
                        for (let request of tempForm.requests) {
                            if (request.needId) {
                                request.entity && (request.entity.id = id);
                                request.data && (request.data.id = id);
                            }
                        }
                    }
                    this.$store.dispatch("api/post", {
                        url: form.api,
                        data: tempForm,
                        commonErrorHandle: false
                    }).then(() => {
                        this.$set(this.runningStatusMap, id, RUN.DONE);
                    }).catch(error => {
                        this.errorMsg[id] = error.response.data.message;
                        this.$set(this.runningStatusMap, id, RUN.FAILED);
                    }).finally(() => {
                        this.doOneByOne(form, index + 1);
                        let temp = this.runningStatusMap[id];
                        if (temp && temp.loading) {
                            this.$set(this.runningStatusMap, id, RUN.FAILED);
                        }
                    });
                    return;
                } else {
                    this.$set(this.runningStatusMap, id, RUN.SKIP);
                }
            }
            this.doOneByOne(form, index + 1);
        },
        checkAllSuccess() {
            for (let row of this.rows) {
                let runStatus = this.runningStatusMap[row.id];
                if (!runStatus || !runStatus.isSucceeded) {
                    return false;
                }
            }
            return true;
        },
        clearRunningStatus() {
            this.runningStatusMap = {};
            this.errorMsg = {};
        },
    }
}
</script>

<style scoped>
.error-msg {
    max-width: 300px;
    word-break: auto-phrase;
}
</style>
